import { mapperModuleMedia, mapperModuleNavigationLink } from '../../../core/data-layer/modules/mappers'
import imageSizes from '../../../core/constants/imageSizes'
import type { MapperImageOptions, MapperOptions } from '#layers/core/types'

/**
 * Page payment methods guides
 * normalizes data to be used in pages
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  const regionImageOptions: MapperImageOptions = {
    sizes: imageSizes.columns6_ratio_11_52_169,
    resize: true,
    lazy: true
  }

  const paymentMethodsOverviewLink = data.globalContentData?.paymentsLabels?.items?.[0]?.paymentMethodsOverviewLink
  return {
    labels: {
      readMore: options.labels?.readMore || ''
    },
    paymentMethodsOverviewLink: mapperModuleNavigationLink(paymentMethodsOverviewLink, options.getUrl),
    subtitle: data.subtitle || '',
    regionPages: data.regionPages?.items
      ? data.regionPages.items.map((item) => ({
          slug: options.getInternalUrl(item?.sys?.id),
          image: mapperModuleMedia(item?.image, regionImageOptions),
          name: item?.name,
          shortDescription: item?.subtitle
        }))
      : []
  }
}
